import { SVGProps } from 'react';

const SvgGoogleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 28 29" {...props}>
    <path
      fill="#FFC107"
      d="M25.44 12.218h-.94v-.049H14v4.667h6.594A6.997 6.997 0 0 1 7 14.503a7 7 0 0 1 7-7c1.785 0 3.408.673 4.644 1.772l3.3-3.3A11.6 11.6 0 0 0 14 2.835c-6.443 0-11.666 5.225-11.666 11.668S7.557 26.169 14 26.169s11.667-5.224 11.667-11.666c0-.783-.08-1.546-.227-2.285"
    />
    <path
      fill="#FF3D00"
      d="m3.679 9.072 3.833 2.811A7 7 0 0 1 14 7.503c1.785 0 3.408.673 4.644 1.772l3.3-3.3A11.6 11.6 0 0 0 14 2.835c-4.481 0-8.367 2.53-10.321 6.237"
    />
    <path
      fill="#4CAF50"
      d="M14 26.169c3.014 0 5.752-1.153 7.822-3.029l-3.61-3.055A6.94 6.94 0 0 1 14 21.502a7 7 0 0 1-6.582-4.635l-3.804 2.931C5.544 23.577 9.466 26.17 14 26.17"
    />
    <path
      fill="#1976D2"
      d="M25.44 12.213h-.94v-.049H14v4.667h6.593a7.02 7.02 0 0 1-2.384 3.25l.002-.002 3.61 3.056c-.255.232 3.846-2.804 3.846-8.638 0-.782-.08-1.545-.227-2.284"
    />
  </svg>
);
export default SvgGoogleIcon;
